/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { TPaginationRequest } from 'shared/types';
import { initialStore } from '../initial-store';

const couponSlice = createSlice({
  name: 'coupon',
  initialState: initialStore.coupon,
  reducers: {
    setCouponData: (state, { payload }) => {
      state.dataCoupons = payload?.data?.result || [];
      state.count = payload?.data?.count || 0;
      state.isLoading = false;
    },
    getCouponData: (
      state,
      data: PayloadAction<TPaginationRequest | undefined>
    ) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    createCouponData: (state, { payload }) => {
      state.isLoading = true;
    },
    actionFail: (state) => {
      state.isLoading = false;
    },
    buildCouponPage: (state, { payload }) => {
      state.isLoading = true;
    },
    updateCouponData: (state, { payload }) => {
      if (!state.isLoading) {
        state.dataIndividualCoupon.isLoadingUpdate = true;
      }
    },
    updateCouponSuccess: (state, { payload }) => {
      state.dataIndividualCoupon.data = payload;
      state.dataIndividualCoupon.isLoadingUpdate = false;
    },
    updateCouponFail: (state) => {
      state.dataIndividualCoupon.isLoadingUpdate = false;
    },

    setIndividualCouponInfo: (state, { payload }) => {
      const data = payload;
      state.dataIndividualCoupon.data = {
        ...data
      };
      state.isLoading = false;
    },
    setCoupon: (state, { payload }) => {
      state.dataIndividualCoupon.data = {
        ...payload
      };
      state.isLoading = false;
    }
  }
});

export const {
  setCouponData,
  getCouponData,
  createCouponData,
  actionFail,
  buildCouponPage,
  setIndividualCouponInfo,
  updateCouponFail,
  updateCouponData,
  updateCouponSuccess,
  setCoupon
} = couponSlice.actions;

export const { reducer } = couponSlice;

// Selectors
export const getCouponsSelector = (state: IState) => {
  return state && state?.coupon?.dataCoupons;
};

export const getCouponsLoadingSelector = (state: IState) =>
  state && state?.coupon?.isLoading;

export const getCouponsLoadingUpdateSelector = (state: IState) =>
  state && state?.coupon?.dataIndividualCoupon?.isLoadingUpdate;

export const getCouponIndividualSelector = (state: IState) =>
  state && {
    data: state.coupon.dataIndividualCoupon.data
  };

export const getCouponCount = (state: IState) => state && state?.coupon?.count;
